export default __webpack_public_path__ + "static/logo-06e16a5df5e97e4e9cea7371c7c6538d.svg";